/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { advancedRoadmapsPlanPageInitialChecksResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planPageWithoutScenarioIdRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planPageWithoutScenarioIdRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { RedirectPlanPageWithoutScenarioIdLoadQuery } from './common/ui/redirect/plan/RedirectPlanPageWithoutScenarioIdPreloadQuery.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';

export const planPageWithoutScenarioIdRouteEntry: Route = createEntry(
	planPageWithoutScenarioIdRoute,

	() => ({
		group: 'software',
		ufoName: 'software-advanced-roadmaps-plan',

		// eslint-disable-next-line no-restricted-syntax
		component: RedirectPlanPageWithoutScenarioIdLoadQuery,

		layout: globalLayout,

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarPlanResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
		],

		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},

		navigation: {
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
